export default "__VITE_ASSET__aYxzrMUQ__"